<template>
  <div>
    <div v-if="relevantWorkFunctions.length === 0" class="tw-text-sm tw-text-gray-400 tw-italic">
      Bitte zuerst Projekte auswählen, um Gewerk-Sätze zu definieren.
    </div>
    <table v-else class="cu-table tw-w-full tw-text-sm">
      <thead>
      <tr>
        <th class="tw-text-left tw-py-2">Gewerk</th>
        <th class="tw-text-left tw-py-2">Stundensatz (€)</th>
        <th class="tw-text-left tw-py-2">Geplante Stunden</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="wf in relevantWorkFunctions" :key="wf.id">
        <td class="tw-py-1 tw-pr-4">{{ wf.label }}</td>
        <td class="tw-py-1 tw-pr-4">
          <input
              :name="`work_function_rates[${wf.id}][hourly_rate]`"
              :value="getRateValue(wf.id, 'hourly_rate')"
              class="tw-border tw-border-border-input tw-rounded tw-px-2 tw-py-1 tw-w-32 tw-text-sm tw-outline-none focus:tw-border-brand-primary"
              min="0"
              placeholder="z.B. 85.00"
              step="0.01"
              type="number"
              @input="setRateValue(wf.id, 'hourly_rate', $event.target.value)"
          >
        </td>
        <td class="tw-py-1">
          <input
              :name="`work_function_rates[${wf.id}][planned_hours]`"
              :value="getRateValue(wf.id, 'planned_hours')"
              class="tw-border tw-border-border-input tw-rounded tw-px-2 tw-py-1 tw-w-32 tw-text-sm tw-outline-none focus:tw-border-brand-primary"
              min="0"
              placeholder="z.B. 120"
              step="0.5"
              type="number"
              @input="setRateValue(wf.id, 'planned_hours', $event.target.value)"
          >
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ReportWorkFunctionRates',

  props: {
    costCarriers: {
      type: Array,
      required: true,
    },
    carrierWorkFunctions: {
      type: Object,
      default: () => ({}),
    },
    allWorkFunctions: {
      type: Array,
      required: true,
    },
    existingRates: {
      type: Array,
      default: () => [],
    },
    initialCarrierIds: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    const ratesMap = {};
    (this.existingRates || []).forEach(rate => {
      ratesMap[rate.user_work_function_id] = {
        hourly_rate: rate.hourly_rate !== null ? rate.hourly_rate : '',
        planned_hours: rate.planned_hours !== null ? rate.planned_hours : '',
      };
    });

    return {
      selectedCarrierIds: [...(this.initialCarrierIds || [])],
      rates: ratesMap,
    };
  },

  computed: {
    // Collect all UWF IDs that appear on any of the currently selected carriers,
    // using the unfiltered server-side map (not the user-filtered tree output).
    relevantWorkFunctionIds() {
      const ids = new Set();
      this.selectedCarrierIds.forEach(carrierId => {
        const fns = this.carrierWorkFunctions[carrierId];
        if (fns) fns.forEach(id => ids.add(id));
      });
      return ids;
    },

    relevantWorkFunctions() {
      return this.allWorkFunctions.filter(wf => this.relevantWorkFunctionIds.has(wf.id));
    },

    calculatedBudget() {
      return this.relevantWorkFunctions.reduce((sum, wf) => {
        const rate = parseFloat(this.rates[wf.id]?.hourly_rate) || 0;
        const hours = parseFloat(this.rates[wf.id]?.planned_hours) || 0;
        return sum + rate * hours;
      }, 0);
    },
  },

  watch: {
    calculatedBudget(val) {
      window.dispatchEvent(new CustomEvent('budget-calculated', {detail: {value: val}}));
    },
  },

  mounted() {
    window.addEventListener('cost-carriers-changed', this.onCarriersChanged);
  },

  beforeDestroy() {
    window.removeEventListener('cost-carriers-changed', this.onCarriersChanged);
  },

  methods: {
    onCarriersChanged(event) {
      this.selectedCarrierIds = event.detail.selectedIds || [];
    },

    getRateValue(workFunctionId, field) {
      return this.rates[workFunctionId]?.[field] ?? '';
    },

    setRateValue(workFunctionId, field, value) {
      if (!this.rates[workFunctionId]) {
        this.$set(this.rates, workFunctionId, {hourly_rate: '', planned_hours: ''});
      }
      this.$set(this.rates[workFunctionId], field, value);
    },
  },
};
</script>
